export enum OrderFormRestorePointType {
  REMOVED_GOOD = 'removedGood',
  REMOVED_LOADING_TIME_WINDOW = 'removedLoadingTimeWindow',
  REMOVED_UNLOADING_TIME_WINDOW = 'removedUnloadingTimeWindow',
  REMOVED_POINT = 'removedPoint',
  MOVED_POINT = 'movedPoint',
}
